import _extends from "@babel/runtime/helpers/esm/extends";
var activeStartDateReducerGen = function activeStartDateReducerGen(args) {
  var momentUtils = args.momentUtils,
    dateCalculator = args.dateCalculator,
    value = args.value,
    viewStore = args.viewStore,
    maxDetail = args.maxDetail;
  var addDate = momentUtils.addDate,
    subtractDate = momentUtils.subtractDate,
    getStartDate = momentUtils.getStartDate;
  var view = viewStore.view;
  return function (state, action) {
    var _action$payload = action.payload,
      payload = _action$payload === void 0 ? {} : _action$payload;
    switch (action.type) {
      case 'goNext':
        return {
          activeStartDateLeft: addDate(state.activeStartDateLeft, 1, view),
          activeStartDateRight: addDate(state.activeStartDateLeft, 2, view)
        };
      case 'goPrev':
        return {
          activeStartDateLeft: subtractDate(state.activeStartDateRight, 2, view),
          activeStartDateRight: subtractDate(state.activeStartDateRight, 1, view)
        };
      case 'directSetActiveStartDate':
        return _extends({}, state, payload);
      case 'setActiveStartDate':
        if (!payload.activeStartDateLeft) {
          var _dateCalculator$calcu = dateCalculator.calculateInitActiveDate(maxDetail, value),
            _initActiveStartDateLeft = _dateCalculator$calcu[0],
            _initActiveStartDateRight = _dateCalculator$calcu[1];
          return {
            activeStartDateLeft: _initActiveStartDateLeft,
            activeStartDateRight: _initActiveStartDateRight
          };
        } else if (!payload.activeStartDateRight) {
          return {
            activeStartDateLeft: payload.activeStartDateLeft,
            activeStartDateRight: addDate(payload.activeStartDateLeft, 1, view)
          };
        } else {
          return {
            activeStartDateLeft: payload.activeStartDateLeft,
            activeStartDateRight: payload.activeStartDateRight
          };
        }
      case 'setActiveStartDateWhenDrillUp':
        var activeStartDate = payload.activeStartDate,
          detail = payload.detail;
        var _dateCalculator$calcu2 = dateCalculator.calculateInitActiveDate(view, getStartDate(activeStartDate, view)),
          nextDrillActiveStartDateLeft = _dateCalculator$calcu2[0],
          nextDrillActiveStartDateRight = _dateCalculator$calcu2[1];
        return {
          activeStartDateLeft: nextDrillActiveStartDateLeft,
          activeStartDateRight: nextDrillActiveStartDateRight
        };
      case 'init':
        var _dateCalculator$calcu3 = dateCalculator.calculateInitActiveDate(maxDetail, value),
          initActiveStartDateLeft = _dateCalculator$calcu3[0],
          initActiveStartDateRight = _dateCalculator$calcu3[1];
        return {
          activeStartDateLeft: initActiveStartDateLeft,
          activeStartDateRight: initActiveStartDateRight
        };
      case 'reset':
        var _dateCalculator$calcu4 = dateCalculator.calculateInitActiveDate(maxDetail),
          resetActiveStartDateLeft = _dateCalculator$calcu4[0],
          resetActiveStartDateRight = _dateCalculator$calcu4[1];
        return {
          activeStartDateLeft: resetActiveStartDateLeft,
          activeStartDateRight: resetActiveStartDateRight
        };
      case 'setActiveStartDateByValue':
        var _dateCalculator$calcu5 = dateCalculator.calculateInitActiveDate(maxDetail, payload.value),
          nextActiveStartDateLeft1 = _dateCalculator$calcu5[0],
          nextActiveStartDateRight1 = _dateCalculator$calcu5[1];
        return {
          activeStartDateLeft: nextActiveStartDateLeft1,
          activeStartDateRight: addDate(nextActiveStartDateLeft1, 1, view)
        };
      default:
        return;
    }
  };
};
export default activeStartDateReducerGen;